import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import _ from "lodash";
import SimpleReactValidator from "simple-react-validator";
import { findItemValueByIdFromArray } from "functions/find-item-by-id-from-array";
import SearchSelect from "components/common/SearchSelect";
import Spinner from "components/common/Spinner";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

class EditCellModal extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            cell:
                this.props.cell.planogramLayoutId && Object.keys(this.props.planogramDataList).length
                    ? this.props.cell
                    : {
                        cellType: 2,
                        caption: "",
                        quantity: 0,
                        planogramDataId: null,
                        planogramLayoutId: 0,
                        ...this.props.cell
                    },
            dataInfo:
                this.props.cell.planogramId && Object.keys(this.props.planogramDataList).length
                    ? findItemValueByIdFromArray(
                        this.props.planogramDataList,
                        "planogramDataId",
                        this.props.cell.planogramDataId
                        )
                    : {
                        slotCode: ""
                    }
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    componentWillReceiveProps(nextProps) {
        const newStates = {};
        if (!_.isEqual(nextProps.planogramDataSingle, this.props.planogramDataSingle)) {
            newStates.planogramDataSingle = nextProps.planogramDataSingle;
        }

        if (Object.keys(newStates).length) {
            this.setState(newStates);
        }
    }

    handleSelect = (name, option) => {
        const newStates = {};

        const infoData = findItemValueByIdFromArray(
            this.props.planogramDataList,
            "slotCode",
            option.value
        );

        const cellData = findItemValueByIdFromArray(
            this.props.planogramLayoutList,
            "planogramDataId",
            infoData.planogramDataId
        );

        const dataInfo = {
            ...this.state.dataInfo,
            slotCode: infoData.slotCode,
            itemCode: infoData.itemCode,
            itemDescription: infoData.itemDescription
        };

        const cell = {
            ...this.state.cell,
            planogramDataId: infoData.planogramDataId,
            caption: cellData.caption,
            quantity: 0
        };

        newStates.dataInfo = dataInfo;
        newStates.cell = cell;
        this.setState(newStates);
    };

    handleInput = (name, value) => {
        const cell = Object.assign({}, this.state.cell);
        cell[name] = value;
        this.setState({ cell });
    };

    handleSave = () => {
        if (this.validator.allValid()) {
            const cell = Object.assign({}, this.state.cell);
            this.props.onSave(cell);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        const {
            loading,
            onCancel,
            planogramDataList
        } = this.props;
        const { dataInfo } = this.state;
        const {
            caption,
            quantity
        } = this.state.cell;

        const slotOptions = planogramDataList.map(value => ({
            value: value.slotCode,
            label: value.slotCode
        }));

        const currentSlotCode = findItemValueByIdFromArray(
            slotOptions,
            "value",
            dataInfo.slotCode
        ) || null;

        return (
            <div className="clearfix position-relative">
                {!loading || <Spinner/>}

                <div className="form-group">
                     <label htmlFor="edit-slot-code">
                        Slot Code:
                    </label>
                    <SearchSelect
                        className="custom-react-select"
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        options={slotOptions}
                        value={currentSlotCode}
                        onChange={(option) => this.handleSelect("slotCode", option)}
                    />
                    {this.validator.message("slotCode", currentSlotCode, "required")}
                </div>

                <hr />
                <div className="form-group">
                    <label htmlFor="edit-item-code">
                        Item:
                    </label>
                    <input
                        id="edit-item-code"
                        className="form-control"
                        type="text"
                        value={dataInfo.itemCode}
                        readOnly
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="edit-desc">
                        Description:
                    </label>
                    <input
                        id="edit-desc"
                        className="form-control"
                        type="text"
                        value={dataInfo.itemDescription}
                        readOnly
                    />
                </div>

                <hr />

                <div className="form-group">
                     <label htmlFor="edit-caption">
                        Caption:
                    </label>
                    <input
                        id="edit-caption"
                        className="form-control"
                        type="text"
                        onChange={ev => this.handleInput("caption", ev.target.value)}
                        value={caption}
                    />
                    {this.validator.message("caption", caption, "required")}
                </div>

                <div className="form-group">
                     <label htmlFor="edit-quantity">
                        Quantity:
                    </label>
                    <input
                        id="edit-quantity"
                        className="form-control"
                        type="text"
                        onChange={ev => this.handleInput("quantity", ev.target.value)}
                        value={quantity}
                    />
                    {this.validator.message("quantity", quantity, "required")}
                </div>

                <div className="text-right">
                    <button
                        className="btn btn-success ml-2"
                        onClick={this.handleSave}
                    >
                        Ok
                    </button>
                    <button
                        className="btn btn-default ml-2"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>

            </div>
        );
    }
}

EditCellModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    loading: state.planogramMaintenance.loading,
    planogramDataList: state.planogramMaintenance.planogramDataList,
    planogramLayoutList: state.planogramMaintenance.planogramLayoutList
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    // getPlanogramDataById: bindActionCreators(getPlanogramDataById, dispatch),
    // createPlanogramData: bindActionCreators(createPlanogramData, dispatch),
    // updatePlanogramDataByDataId: bindActionCreators(updatePlanogramDataByDataId, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(EditCellModal);
